import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { KironPlayerComponent } from '../../../alert/kiron-player/kiron-player.component';
import { BettingServiceService } from "../../../../services/betting_service/betting-service.service";
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../alert/alert.component';

import { Subscription } from 'rxjs';
import { interval } from 'rxjs';
import { PlayerModalComponent } from 'src/app/components/alert/player-modal/player-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cricket-super-over',
  templateUrl: './cricket-super-over.component.html',
  styleUrls: ['./cricket-super-over.component.scss'],
})
export class CricketSuperOverComponent implements OnInit {

  kironResults: any = [];
  kironResultsMeetingCode: any = "";

  Kiron4VideoUrl: any;

  is_logged = false;

  videoPopup: HTMLIonModalElement;

  ODDs: any = [];
  viewSelectionBlock: boolean;
  tempObj: any = [];
  selectedMeeting: any;
  shownOdd: any;

  selectionType: string = "";
  maxCount: boolean = false;
  selection: any = {
    eventSelections: []
  };
  subscription: Subscription;
  disable_SP_subscription: Subscription;
  matchWinner: string = "Match Winner";
  allData: any;

  // odd refresh
  oddRefresh: Subscription;
  counter = 30;
  scrollId: string;

  currentSelectedBets: any = null;    // Block Games

  constructor(public modalController: ModalController,
    public betting_service: BettingServiceService,
    public translate: TranslateService,
    private commanService: CommonServiceService,
    private stmgService: StmgService,
    public alertController: AlertController,
    public renderer: Renderer2, public ele: ElementRef
  ) {
    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      //this.getMeetingData(this.selectedBetCategory);
      this.ODDs.forEach(element => {
        if (element.matchWinner.length > 0) {
          element.matchWinner.forEach(element2 => {
            let i = 0;
            element2.clicked = false;
            i++;
          });
        }
      });
    })

  }

  mySubscription: Subscription;

  ngOnInit() {

    this.get_kiron_results();

    this.getMeetingData();

    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    this.viewSelectionBlock = false;

    this.stmgService.cast_clickStatus.subscribe(clicked => {
      this.viewSelectionBlock = clicked;
      if (!clicked) {
        let el = document.getElementById(this.scrollId);
        setTimeout(() => {
          el.scrollIntoView();
        }, 100);
      }
    });

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if (selectedBets) {
        this.selection = selectedBets;
      }
    });

    this.stmgService.nav2SportRefresh_status.subscribe(clicked => {
      if (clicked == 'yes') {
        this.ngOnChanges();
      }
    });

    this.is_no_data = false;

    // Odd Refresh - run every 30 sec.
    this.oddRefresh = interval(60000).subscribe((x => {
      this.getMeetingData();
      this.counter = 60;
    }));

    // Block Games
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });
  }

  cricketSuperResultMettingCode(value: string): string {
    if (!value) return '';

    const parts = value.split('-');
    if (parts.length > 1) {
      return parts[parts.length - 1];
    }
    return '';
  }


  ngOnChanges() {

    this.ODDs = [];
    this.tempObj = [];
    this.viewSelectionBlock = false;
    this.getMeetingData();

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if (selectedBets) {
        this.selection = selectedBets;
      }
    });

    this.is_no_data = false;

  }

  viewSportDetails(d: any, event) {
    let myTag = this.ele.nativeElement.querySelectorAll(".sub-item");
    myTag.forEach(ele => {
      ele.classList.remove('sub-item-selected');
    })

    let element = event.target;
    for (let index = 0; index < 10; index++) {
      if (element.classList.contains('sub-item')) {
        this.renderer.addClass(element, 'sub-item-selected');
        break;
      } else {
        element = element.parentNode;
      }
    }

    this.viewSelectionBlock = true;
    this.selectedMeeting = d;

  }

  getOddData(oddId, index) {

    // get meetings by event id
    this.betting_service.getCricketSuperOverMeetingDataById(oddId).subscribe(data => {
      let d = this.trimObj(data);
      if (d) {
        for (let m = 0; m < d.length; m++) {
          this.ODDs[index].eventData.push(d[m]);
        }

        console.log("aaaaaaaaaaaaaa", this.ODDs)
      }
    }, (error) => {
    });

    this.shownOdd = '';
    if (this.isOddShown(oddId)) {
      this.shownOdd = null;
    } else {
      this.shownOdd = oddId;
    }
  }
  isOddShown(id) {

    return this.shownOdd === id;
  }

  // Get Meeting Data
  getMeetingData() {

    this.betting_service.getCricketSuperOverMeetingData().subscribe(data => {
      this.validatePayload(data);
    }, (error) => {

    });

  }


  is_no_data = false;
  validatePayload(data: any) {
    if (data.status !== 'success' || !data.payload.length) {
      this.is_no_data = true;
    } else {
      this.createSportDataObj(data);
      this.updateMeetingDataSTMG(data);
    }
  }

  createSportDataObj(data) {

    let tempData = data.payload;
    this.allData = data.payload;
    let selectedId: number;

    for (let i = 0; i < tempData.length; i++) {
      this.tempObj[i] = {
        id: tempData[i].meetingId,
        meetingName: tempData[i].meetingName,
        meetingCode: tempData[i].meetingCode,
        meetingLocalTime: tempData[i].meetingLocalTime,
        sel1Name: tempData[i].sel1Name.slice(0, 3).toUpperCase(),
        sel2Name: tempData[i].sel2Name.slice(0, 3).toUpperCase(),
        eventData: [],
        matchWinner: [{
          id: tempData[i].sel1Id,
          name: tempData[i].sel1Name,
          lastOddDec: tempData[i].sel1PriceDec,
          sel1PriceFrac: tempData[i].sel1PriceFrac
        },
        {
          id: tempData[i].sel2Id,
          name: tempData[i].sel2Name,
          lastOddDec: tempData[i].sel2PriceDec,
          sel1PriceFrac: tempData[i].sel2PriceFrac
        },
        {
          id: tempData[i].sel3Id,
          name: tempData[i].sel3Name,
          lastOddDec: tempData[i].sel3PriceDec,
          sel1PriceFrac: tempData[i].sel3PriceFrac
        }
        ]

      };

      //if draw position changed swap the macth winner position
      if (this.tempObj[i].matchWinner[1].name == "Draw" || this.tempObj[i].matchWinner[1].name == "Tie") {
        this.tempObj[i].matchWinner[2] = {
          id: tempData[i].sel2Id,
          name: tempData[i].sel2Name,
          lastOddDec: tempData[i].sel2PriceDec,
          sel1PriceFrac: tempData[i].sel2PriceFrac
        }

        this.tempObj[i].matchWinner[1] = {
          id: tempData[i].sel3Id,
          name: tempData[i].sel3Name,
          lastOddDec: tempData[i].sel3PriceDec,
          sel1PriceFrac: tempData[i].sel3PriceFrac
        }
      }


      // // get meetings by event id
      // this.betting_service.getCricketSuperOverMeetingDataById(this.tempObj[i].id).subscribe(data => {
      //   let d = this.trimObj(data);
      //   if(d){
      //     for (let m = 0; m < d.length; m++) {
      //       this.tempObj[i].eventData.push(d[m]);
      //     }
      //   }
      // }, (error) => {
      // });
    }

    // Sort data by meetingId
    this.tempObj.sort((a, b) => a.id - b.id);

    this.ODDs = this.tempObj;
  }

  trimObj(data: any) {
    let trimObjData;
    if (data.payload[0]) {
      trimObjData = data.payload[0].eventLightDTOs;
    }
    return trimObjData;
  }

  updateMeetingDataSTMG(d: any) {
    this.stmgService.updateMeetingData(d);
  }



  setSPOdd(value: any) {
    this.selectionType = 'SP';
    value.clicked = !value.clicked;
    if (value.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }
  }


  // checkMaximuSelectionCount() {
  //   let val: boolean;
  //   let selectionArray = this.selection.eventSelections.filter(m => !m.isKR3)
  //   if (selectionArray.length == 4) {
  //     val = true;
  //   } else {
  //     val = false;
  //   }
  //   return val;
  // }

  checkMaximuSelectionCount(): boolean {

    if (!this.selection || !this.selection.eventSelections) {
      return false;
    }

    const selectionArray = this.selection.eventSelections.filter(m => !m?.isKR3);

    return selectionArray.length === 4;
  }


  placeBetObj(d: any, t: string) {

    // Block Games Selections
    if (!this.selection) {
      this.selection = { eventSelections: [] };
    }
    if (!this.selection.eventSelections) {
      this.selection.eventSelections = [];
    }

    // **CHECK if game bets exist**
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      console.log('e-Cricket - Inside check, currentBets exists');
      
      const isKironGame = this.currentSelectedBets.payload && (this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions');
      console.log('e-Cricket - isKironGame:', isKironGame);
      
      if (isKironGame && this.currentSelectedBets.payload.eventSelections) {
        const hasGameBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        console.log('e-Cricket - hasGameBets:', hasGameBets);
        
        if (hasGameBets) {
          this.showBlockAlert();
          d.clicked = false;
          d.fr_clicked = false;
          return;
        }
      }
    }

    let oddD: any;
    let oddF: any;
    let win: number = 0;
    let place: number = 0;


    switch (t) {

      case 'SP':
        oddF = 'N';
        oddD = 0.0;
        break;

      case 'PO':
        oddF = d.priceOdds.priceFraction;
        oddD = 0.0;
        break;

      case 'PD':
        oddF = 'N';
        oddD = d.priceOdds.priceDecimal;
        break;
    }

    let tempObj = {
      id: d.id,
      oddD: oddD,
      oddF: oddF,
      win: win,
      place: place,
      sportType: d.id
    }

    if (d.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      let index = -1;
      for (let i = 0; i < this.selection.eventSelections.length; i++) {

        if (this.selection.eventSelections[i].id == d.id) {
          index = i;
          break;
        }

      }

      // add row
      if (index == -1) {
        this.selection.eventSelections.push(tempObj);
      }


    } else {
      let index = -1;
      for (let i = 0; i < this.selection.eventSelections.length; i++) {

        if (this.selection.eventSelections[i].id == d.id) {
          index = i;
          // remove row
          this.selection.eventSelections.splice(index, 1);
          break;
        }

      }
    }

    this.stmgService.updateSelecteBets(this.selection);
  }


  showMaxCountAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }



  colorChange(event, i) {
    console.log(event.target);
    console.log("scrollto ", i)

    this.scrollId = "scrollto" + i

    let myTag = this.ele.nativeElement.querySelectorAll(".betting-category");
    myTag.forEach(ele => {
      ele.classList.remove('selected');
    })

    let element = event.target;
    for (let index = 0; index < 10; index++) {
      if (element.id == "dropdown") {
        this.renderer.addClass(element, 'selected');
        break;
      } else {
        element = element.parentNode;
      }
    }
  }



  resultExplan(event, i) {

    console.log("scrollto ", i)

    this.scrollId = "scrollto" + i

    let myTag = this.ele.nativeElement.querySelectorAll(".race-preview");
    myTag.forEach(ele => {
      ele.classList.remove('selected');
    })

    console.log(event.target);

    let element = event.target;
    for (let index = 0; index < 10; index++) {
      if (element.id == "dropdownResult") {
        this.renderer.addClass(element, 'selected');
        break;
      } else {
        element = element.parentNode;
      }
    }
  }



  //kiron result method
  get_kiron_results() {
    this.betting_service.getKiron4Result().subscribe(
      (data) => {
        this.kironResults = data;
        // this.kironResults = this.kironResults.reverse();
        this.kironResultsMeetingCode = this.cricketSuperResultMettingCode(this.kironResults[0]?.meetingCode
        );
      },
      (error) => {
        //console.log(error);
      }
    );
  }

  //open video player
  async open_player() {
    const modal = await this.modalController.create({
      component: PlayerModalComponent,
      cssClass: 'customPopup',
      componentProps: { videoUrl: this.Kiron4VideoUrl }
    });
    this.videoPopup = modal;
    modal.onDidDismiss().then(data => {
      this.videoPopup = null
    })
    return await modal.present();
  }

  //video button click function
  video_clicked() {
    if (this.is_logged) {
      //get kiron dg video
      this.betting_service.getKiron4VideoUrl(this.commanService.getToken()).subscribe(
        (data) => {
          console.log(data['url']);
          this.Kiron4VideoUrl = data['url'];
          //only open one popup
          if (!this.videoPopup || this.videoPopup == null) {
            this.open_player()
          }
        },
        (error) => {
          //console.log(error);
        }
      );

    }
    else {
      let alertTitle: string;
      let alertDesc: string;
      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe((res: string) => {
        alertTitle = res;
      });
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe((res: string) => {
        alertDesc = res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }

  }

  //stop the loop
  ngOnDestroy() {
    this.mySubscription?.unsubscribe();
    console.log("unsubsccribe")
    this.disable_SP_subscription.unsubscribe()
    this.oddRefresh.unsubscribe();
  }

  // Block Slecetion with Games
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

}
